/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 *
 * Created by sjacobs on 1/29/19.
 */

'use strict';

angular.module('prism-ui.components').service('PackageCreationTemplatesService', function (
    this: JS5Object, _: JS5Object, PackageCreationTemplatesResourceFactory: JS5Object) {
    this.permissionViewState = 'DASHBOARD_TERRITORIES_VIEW_STATE';
    this.originalEditData = {};
    this.getAllPackageCreationTemplates = (queryParams: JS5Object, queryHandler: JS5Function) => {
        return PackageCreationTemplatesResourceFactory.query(queryParams, queryHandler).$promise;
    };
    this.getPackageCreationTemplate = (id: number) => {
        return PackageCreationTemplatesResourceFactory.getPackageCreationTemplate({id: id}).$promise;
    };
    this.createPackageCreationTemplate = (PackageCreationTemplate: JS5Object) => {
        return PackageCreationTemplatesResourceFactory.createPackageCreationTemplate(PackageCreationTemplate).$promise;
    };
    this.updatePackageCreationTemplate = (PackageCreationTemplate: JS5Object) => {
        return PackageCreationTemplatesResourceFactory.updatePackageCreationTemplate(PackageCreationTemplate).$promise;
    };
    this.deletePackageCreationTemplate = (id: number) => {
        return PackageCreationTemplatesResourceFactory.deletePackageCreationTemplate({id: id}).$promise;
    };
});
